export const fiscalTest = {
	testing: "Probar datos fiscales ({{count}})",
	testingMessage: "Probando {{count}} producto(s) seleccionado(s)...",
	testingProgress: "{{tested}} de {{total}} probados",
	successTitle: "Probar datos fiscales ({{count}})",
	successMessage: "¡Todos los productos fueron probados con éxito!",
	successMainText: "Datos fiscales probados con éxito",
	successSubText: "No se encontraron errores en los datos presentados",
	errorTitle: "Probar datos fiscales ({{count}})",
	errorMessage: "Ops... Algo no salió como estaba planeado.",
	errorSubMessage: "Encontramos errores en los datos fiscales presentados",
	errorMainText: "Ops... Algo no salió como estaba planeado.",
	errorSubText: "Encontramos errores en los datos fiscales presentados",
	success: "Datos fiscales probados con éxito",
	error: "Error al probar datos fiscales",
	unknownError: "Error desconocido",
	errorTableProduct: "Producto",
	errorTableMessage: "Error",
};
